import BasicMultipleSelect from "./BasicMultipleSelect";
export default BasicMultipleSelect;
